<script>
  /** @type {'basic'|'basic-negative'|'primary'|'secondary'|'destructive'|'plain'} */
  export let type = "basic";

  /** @type {boolean} */
  export let iconOnly = false;

  /** @type {string} */
  export let id = undefined;

  /** @type {string} */
  export let cssClass = "";

  /** @type {string} */
  export let text = "";

  /** @type {boolean} */
  export let large = false;

  /** @type {boolean} */
  export let disabled = false;

  /** @type {boolean} */
  export let loading = false;

  /** @type {'submit'|'button'|'reset'} */
  export let htmlType = "submit";

  /** @type {'false'|'true'|'menu'|'listbox'|'tree'|'grid'|'dialog'} */
  export let haspopup = undefined;

  /** @type {boolean} */
  export let expanded = undefined;

  /** @type {string | undefined} */
  export let ariaLabel = undefined;

  /** @type {string | undefined} */
  export let describedby = undefined;

  /** @type {string | undefined} */
  export let labelledby = undefined;

  $: visuallyHidden = iconOnly ? "prom-button__text--hidden" : "";
  $: isLarge = large ? "prom-button--large" : "";
  $: isLoading = loading ? "prom-button--loading" : "";
  $: isActive = !loading && !disabled;
  $: ariaLabelText = ariaLabel 
    ? ariaLabel
    : (iconOnly ? text : undefined);
</script>

<button
  aria-haspopup={haspopup}
  aria-expanded={expanded}
  aria-label={ariaLabelText}
  aria-labelledby={labelledby}
  aria-describedby={describedby}
  {id}
  type={htmlType}
  class="prom-button prom-button__{type} {cssClass} {isLoading} {isLarge}"
  {disabled}
  data-active={isActive}
  on:click
  on:focus
  on:blur
  on:keyup
  on:keydown
>
  <span class="prom-button__text">
    <span class={visuallyHidden}>{text}</span>
  </span>
</button>
